import { Currency, OrderPayment } from 'common/types';
import { getPaymentAmountsFromOrderPayment } from '../paymentAmounts';
import { DepositPricing } from '../pricing';

export const hasDeposit = (deposit?: DepositPricing): deposit is DepositPricing => {
	const depositType = deposit?.type ?? 'payment';
	return depositType === 'other' || depositType === 'no-deposit' || hasMoneyDeposit(deposit);
};

export const hasMoneyDeposit = (deposit?: DepositPricing) => {
	const depositType = deposit?.type ?? 'payment';
	return depositType === 'payment' && (deposit?.value || 0) > 0;
};

export const hasOtherDeposit = (deposit?: DepositPricing) => {
	const depositType = deposit?.type ?? 'payment';
	return depositType === 'other';
};

export const hasUnreservedMoneyDeposit = (
	deposit: DepositPricing | undefined,
	payment: OrderPayment,
	currency: Currency,
) => {
	if (!deposit) {
		return false;
	}
	const depositType = deposit.type ?? 'payment';
	const paymentAmount = getPaymentAmountsFromOrderPayment(deposit.value, currency, payment);
	const unreservedAmount = paymentAmount.unreserved;

	return depositType === 'payment' && unreservedAmount > 0;
};

export const hasUnreleasedMoneyDeposit = (
	deposit: DepositPricing | undefined,
	payment: OrderPayment,
) => {
	const depositType = deposit?.type ?? 'payment';
	return (
		depositType === 'payment' &&
		(payment.authorised || 0) > (payment.cancelled || 0) + (payment.captured || 0)
	);
};

export const hasUnreleasedDeposit = (
	deposit: DepositPricing | undefined,
	payment: OrderPayment,
) => {
	return hasOtherDeposit(deposit) || hasUnreleasedMoneyDeposit(deposit, payment);
};
